import { View, Text, StyleSheet } from 'react-native'
import { router } from 'expo-router'
import { Like } from '@/src/assets/icons/Like'
import { useDisableSwipingBackToThePreviousPage } from '@/src/common/hooks/disableSwipingBackToThePreviousPage'
import { StandaloneWrapper } from '@/src/common/wrappers/StandaloneWrapper'
import { DesignSystem } from '@/src/design-system'
import { mesaColorNames, typography } from '@/src/common/theme'
import { Button } from '@/src/common/components/Button'
import * as Surveys from '@/src/experiences/surveys'
import * as Hooks from '../../hooks'

export function SuccessConfirmation() {
  const { pointsToRedeem, remainingPoints, creditAmount, conversionRate } =
    Hooks.usePointsToStatementCredit()

  useDisableSwipingBackToThePreviousPage()
  Surveys.Hooks.useScreenUnmountTrigger('rewards_statement_credit_success')

  return (
    <StandaloneWrapper
      screen="/main/points-to-statement-credit/success-confirmation"
      title="Statement Credit Confirmation"
      profileProps={{ menuIconProps: { color: mesaColorNames['Mesa - Brand/White #FFFFFF'] } }}
      onBackPress={() => router.dismissTo('/main/home')}
    >
      <View style={styles.successContainer}>
        <View style={styles.successIcon}>
          <Like />
        </View>
        <Text style={[typography['heading/heading3'], styles.successText]}>
          Mesa Points successfully redeemed
        </Text>
      </View>

      <DesignSystem.PointsRedemption.PointsRedemptionConfirmationInfoCard
        pointsToRedeem={pointsToRedeem ? parseInt(pointsToRedeem) : 0}
        // the remaining points is the current points balance because this screen should only be displayed after the points have been redeemed
        remainingPoints={remainingPoints ? parseInt(remainingPoints) : 0}
        creditAmount={creditAmount ? parseInt(creditAmount) : 0}
        conversionRate={conversionRate ?? ''}
      />

      <Button onPress={() => router.dismissTo('/main/home')} title="Return Home" />

      <Text style={[typography.S, styles.infoText]}>
        Statement credits are generally posted to your account within 24 hours. However, if redeemed
        outside of business hours, posting may be delayed.
      </Text>
    </StandaloneWrapper>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: mesaColorNames['Mesa - Brand/Secondary #223843'],
    paddingHorizontal: 14,
    gap: 32,
    color: mesaColorNames['global/grey/80 #2F3133'],
  },
  successContainer: {
    gap: 16,
    alignItems: 'center',
    paddingVertical: 20,
  },
  successIcon: {
    backgroundColor: mesaColorNames['Mesa Primary Scale/400 - Brand #00DFC9'],
    borderRadius: 48,
    padding: 16,
    alignItems: 'center',
  },
  successText: {
    color: mesaColorNames['Mesa - Brand/White #FFFFFF'],
  },
  infoText: {
    color: mesaColorNames['Mesa - Brand/White #FFFFFF'],
    textAlign: 'center',
    marginBottom: 40,
  },
})
